import { render } from "./performance.vue?vue&type=template&id=1dcb3d84"
import script from "./performance.js?vue&type=script&lang=js&external"
export * from "./performance.js?vue&type=script&lang=js&external"

import "./performance.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__